import React from 'react';
import SolutionRegistration from './SolutionRegistration';

const SolutionRegistrationContainer = () => {
  return <SolutionRegistration />;
};

export default React.memo(SolutionRegistrationContainer);
